import React, { useEffect, useMemo, useState } from "react";
import Layout from "../../../components/Layout";
import avatar from "../../../assets/img/avatar.svg";
import { useAuth } from "../../../context/ContextApi";
import { parseISO, formatDistance } from "date-fns";
import pt from "date-fns/locale/pt";

import ChatView from "../Chat/components/ChatView";
import "./Chat.scss";
import { formatWithOptions } from "date-fns/fp";
import api from "../../../config/api";
import EmptyContentLittle from "../../../components/EmptyContent/EmptyContentLittle";

require("dotenv").config();

function Chat(props) {
  const [chats, setChats] = useState([]);
  const [searchedChats, setSearchedChats] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [isChatsLoading, setIsChatsLoading] = useState(true);
  const [selectedChat, setSelectedChat] = useState("");
  const { userToken } = useAuth();
  const config = useMemo(() => ({ headers: { Authorization: "Bearer " + userToken } }), [userToken]);
  const handleChangeChatsSearchQuery = (value) => {
    setSearchQuery(value);
  };

  useEffect(() => {
    if (searchQuery) {
      setSearchedChats(chats.filter((chat) => chat.user.name.toLowerCase().includes(searchQuery.toLowerCase())));
    } else {
      setSearchedChats(chats);
    }
  }, [searchQuery, chats]);
  useEffect(() => {
    const getChats = async () => {
      try {
        await api
          .get(`/chat`, config)
          .then(function (response) {
            const data = response.data.map((chat) => ({
              ...chat,
              formattedUpdatedAt: formatWithOptions({ locale: pt }, "d MMMM")(parseISO(chat.updatedAt)),
              timeDistance: formatDistance(parseISO(chat.updatedAt), new Date(), {
                addSuffix: true,
                locale: pt,
              }),
            }));

            setChats(data);
            const mostRecentChat =
              data.length > 0 &&
              data.reduce((a, b) => {
                return new Date(a.updatedAt) > new Date(b.updatedAt) ? a : b;
              });
            let idChat = "";
            if (props.match.params.id !== "ver") {
              idChat = props.match.params.id;
            } else {
              idChat = mostRecentChat?._id;
            }
            setSelectedChat(idChat);
            setChatMessagesRead(idChat);
          })
          .catch(function (error) {
            console.log(error);
          })
          .finally(() => setIsChatsLoading(false));
      } catch (err) {
        console.log(err);
      }
    };
    config && getChats(userToken);
  }, [config, userToken]);

  const setChatMessagesRead = async (chatId) => {
    if (!chatId) return;
    await api
      .put(`/replies-read/${chatId}`, config)
      .then((res) => {})
      .catch((err) => {
        console.log("error setting chat messages read");
        console.log(err);
      });
  };
  useEffect(() => {
    setChats((chats) => chats.map((chat) => (chat._id === selectedChat ? { ...chat, unreadMessages: 0 } : chat)));
    setChatMessagesRead(selectedChat);
  }, [selectedChat]);

  return (
    <>
      <Layout defaultMenu={4} title={"Chat"} link={""}>
        <div id="chat-page-container" className="store container-fluid  pt-1">
          <div className="col-12 col-lg-3 col-md-3 card me-3">
            <div className="mb-2">
              <div className="input-group input-search-chat">
                <input
                  onChange={(e) => handleChangeChatsSearchQuery(e.target.value)}
                  type="text"
                  className="form-control fz-14 border-0 box-shadow-none text-cl-auroMetal ff-roboto"
                  placeholder="Buscar"
                />
                <span className="input-group-text bg-white border-0">
                  <i className="bi bi-search text-cl-auroMetal"></i>
                </span>
              </div>
            </div>
            <div className="chat-notifications-container overflow-auto">
              {isChatsLoading ? (
                <>
                  {/* <ChatItemLoadingSkeleton />
                  <ChatItemLoadingSkeleton />
                  <ChatItemLoadingSkeleton />
                  <ChatItemLoadingSkeleton /> */}
                </>
              ) : searchedChats?.length === 0 ? (
                <div className="col-lg-12 justify-content-center align-items-center d-flex">
                  <EmptyContentLittle description={"Não existem conversas recentes"} />
                </div>
              ) : (
                searchedChats.map((chat, index) => (
                  <div
                    key={index}
                    className={`py-2 px-4 d-flex justify-content-between hover-cultured-3 c-pointer ${
                      selectedChat === chat?._id ? "active" : ""
                    }`}
                    id={chat?._id}
                    onClick={() => setSelectedChat(chat?._id)}
                  >
                    <div className="d-flex">
                      <figure className="user-avatar-wrapper">
                        <img
                          width={40}
                          className="img-fluid avatar m-0"
                          src={
                            chat.clientReservation?.user.avatar
                              ? chat.clientReservation?.user.avatar
                              : chat.user?.avatar
                              ? chat.user?.avatar
                              : avatar
                          }
                          alt={chat?.clientReservation?.user.name ? chat?.clientReservation?.user.name : chat.user.name}
                        />
                      </figure>

                      <div className="flex-column d-flex justify-content-center ms-2">
                        <span className="d-block text-cl-black-2 ff-univanova fz-12">
                          {chat?.clientReservation?.user.name ? chat?.clientReservation?.user.name : chat.user.name}
                        </span>
                        <span className="d-block text-cl-arsenic ff-univanova fz-10">{chat?.timeDistance}</span>
                      </div>
                    </div>
                    <div className="d-flex flex-column justify-content-center align-items-end">
                      <span className="d-block text-cl-black-2 ff-univanova fz-12 text-capitalize">
                        {chat?.formattedUpdatedAt}
                      </span>
                      {chat?.unreadMessages > 0 && (
                        <div className="d-flex justify-content-center align-items-center bg-cl-red chat-notifications-count">
                          {chat?.unreadMessages}
                        </div>
                      )}
                    </div>
                  </div>
                ))
              )}
            </div>
          </div>

          <ChatView {...{ selectedChat }} />
        </div>
      </Layout>
    </>
  );
}

export default Chat;
